<template>
  <div class="toolbar-timeline__content elevation-0 px-0 px-sm-5">
    <v-row class="pb-3">
      <v-col cols="12" sm="6" md="auto">
        <p class="primary--text font-weight-bold mb-0 toolbar-timeline__title">
          SOLICITAÇÃO - {{ quotation.numero }}
          <v-tooltip bottom content-class="tooltip-label-form">
            <template v-slot:activator="{ on }">
              <v-icon color="secondary" size="10" v-on="on">
                fa-info-circle
              </v-icon>
            </template>
            <v-row>
              <v-col cols="12" class="px-4 py-3">
                <p class="white--text tooltip-label-text mb-0">
                  Este é o identificador único da sua solicitação. Utilize-o
                  para encontrar sua cotação, acompanhar a evolução e comunicar
                  com outras pessoas.
                </p>
              </v-col>
            </v-row>
          </v-tooltip>
        </p>
      </v-col>
      <v-spacer class="d-none d-md-flex" />
      <v-col
        cols="12"
        sm="6"
        md="auto"
        class="text-sm-end pr-5"
        v-if="numberProcess"
      >
        <p class="mb-1 body-2 primary--text">
          N° do Processo Judicial
          <v-tooltip bottom content-class="tooltip-label-form">
            <template v-slot:activator="{ on }">
              <v-icon color="secondary" size="10" v-on="on">
                fa-info-circle
              </v-icon>
            </template>
            <v-row>
              <v-col cols="12" class="px-4 py-3">
                <p class="white--text tooltip-label-text mb-0">
                  Identificador único de processos que possibilita a localização
                  dos mesmos. Possui o seguinte formato: NNNNNNN-DD.
                  AAAA.J.TR.OOOO.
                </p>
              </v-col>
            </v-row>
          </v-tooltip>
        </p>
        <p class="mb-0 font-weight-bold secondary--text toolbar-timeline__text">
          {{ numberProcess }}
        </p>
      </v-col>
      <v-col
        cols="6"
        md="auto"
        class="pl-md-5 py-5 py-md-0 pr-5"
        v-if="!dontShowHistoric"
      >
        <BaseButton
          v-html="'VER HISTÓRICO'"
          color="secondary"
          outlined
          width="100%"
          @click="redirectToHistorical"
        />
      </v-col>
      <v-col cols="6" md="auto" class="py-5 py-md-0" v-if="!dontShowResume">
        <BaseButton
          v-html="'RESUMO DA COTAÇÃO'"
          class="secondary"
          width="100%"
          @click="redirectToResume"
        />
      </v-col>
    </v-row>
    <v-row class="toolbar-timeline__row">
      <v-col cols="12" class="toolbar-timeline__col pt-5 pb-5 pb-sm-0">
        <div
          v-for="(item, key) of statusItems"
          :key="key"
          class="toolbar-timeline__step"
        >
          <div class="toolbar-timeline__line-wrap-left" v-if="key > 0" />
          <v-avatar
            :class="colorStep(item) + ' toolbar-timeline__step-icon'"
            size="30"
          >
            <img
              v-if="showIcon(item)"
              :src="iconStep(item)"
              class="toolbar-timeline__img"
            />
          </v-avatar>
          <div
            class="toolbar-timeline__line-wrap-right"
            v-if="key < statusItems.length - 1"
          />
        </div>
      </v-col>
      <v-col cols="12" class="toolbar-timeline__col pb-5">
        <div
          v-for="(item, key) of statusItems"
          :key="key"
          class="toolbar-timeline__step"
        >
          <v-toolbar-title :class="colorText(item) + ' justify-center pt-3'">
            {{ item.name }}
          </v-toolbar-title>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="auto" class="pr-5">
        <v-avatar class="lightYellow" size="10" />
        <p class="primary--text body-2 d-inline">
          Em realização
        </p>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-avatar class="lightGreen" size="10" />
        <p class="primary--text body-2 d-inline">
          Realizado
        </p>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-avatar class="pink" size="10" />
        <p class="primary--text body-2 d-inline">
          Cancelado
        </p>
      </v-col>
      <v-col cols="auto">
        <v-avatar class="toolbar-timeline__avatar" size="10" />
        <p class="primary--text body-2 d-inline">
          Não realizado
        </p>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  computed: {
    numberProcess() {
      return this.quotation.processo?.numero_processo;
    },
    dontShowHistoric() {
      return (
        this.quotation.status.id == "em_andamento" &&
        !this.quotation.minuta &&
        !this.quotation.apolice
      );
    },
    currentStep() {
      return this.quotation.passos.find(
        x => x.status.id == "em_realizacao" || x.status.id == "cancelado"
      );
    },
    dontShowResume() {
      return (
        this.currentStep &&
        this.currentStep.id == "dados_processo" &&
        !this.quotation.minuta &&
        this.quotation.status.id != "cancelada"
      );
    }
  },
  methods: {
    colorStep(item) {
      const color =
        (this.findItem(item) == "nao_realizado" && "white") ||
        (this.findItem(item) == "realizado" && "green") ||
        (this.findItem(item) == "em_realizacao" && "yellow") ||
        "red";
      return `toolbar-timeline__background-${color}`;
    },
    colorText(item) {
      const color =
        this.findItem(item) == "nao_realizado"
          ? "lightBlue--text"
          : "primary--text";
      return `toolbar-timeline__text font-weight-medium ${color}`;
    },
    iconStep(item) {
      const icon =
        (this.quotation.acoes.processo.executando_acao_em_segundo_plano &&
          this.findItem(item) == "em_realizacao" &&
          require("@/assets/loading_policy.svg")) ||
        (this.findItem(item) == "em_realizacao" &&
          require("@/assets/ic_wait.svg")) ||
        (this.findItem(item) == "realizado" &&
          require("@/assets/ic_check.svg")) ||
        (this.findItem(item) == "cancelado" &&
          require("@/assets/ic_close.svg")) ||
        null;
      return icon;
    },
    showIcon(item) {
      return this.findItem(item) != "nao_realizado";
    },
    findItem(item) {
      var status = this.quotation.passos.find(x => x.id == item.id).status.id;

      if (status == "cancelado") {
        var index = this.statusItems.indexOf(item);
        var breakItemid = this.quotation.passos.find(x => x.status.id == "nao_realizado").id;
        var breakItem = this.statusItems.find(x => x.id == breakItemid);

        if (breakItem != null) {
          var breakIndex = this.statusItems.indexOf(breakItem);

          if (index < breakIndex -1) {
            return "realizado";
          }
        }
      }

      return this.quotation.passos.find(x => x.id == item.id).status.id;
    },
    redirectToResume() {
      this.$router.push({ name: "quotation resume" });
    },
    redirectToHistorical() {
      this.$router.push({ name: "quotation historical" });
    }
  },
  props: {
    quotation: {
      type: Object
    },
    statusItems: {
      type: Array
    }
  }
};
</script>
<style lang="sass">
.toolbar-timeline__
  &background-white
    border: 2px solid #E5E5ED
    background-color: #FFFFFF
  &background-green
    background-color: #49DCBB
  &background-yellow
    background-color: #FFEDB9
  &background-red
    background-color: #EF5350
  &content
    z-index: 6
    align-items: center
  &text
    font-size: 14px
    @media(max-width:960px)
      font-size: 12px
  &title
    font-size: 18px
  &col
    display: flex
    flex-wrap: wrap
  &row
    border: 1px solid #D5D5E0
    border-radius: 4px
    background-color: #FFFFFF
  &step
    flex: 1
    justify-content: center
    text-align: center
    position: relative
  &img
    width: 60% !important
  &avatar
    border: 1px solid #E5E5ED
    background-color: #FFFFFF
  &line-wrap-left
    width: 50%
    border: 1px solid rgba(213,213,224,0.51)
    top: 50%
    position: absolute
  &line-wrap-right
    width: 50%
    border: 1px solid rgba(213,213,224,0.51)
    top: 50%
    position: absolute
    right: 0
  &step-icon
    z-index: 1
</style>
